import "./index.scss";
import Input from "../../components/Input";
import {Link, useNavigate} from "react-router-dom";
import CheckBox from "../../components/CheckBox";
import {setTokens, setUser} from "../../redux/auth";
import {useDispatch} from "react-redux";
import {useState, useRef} from "react";
import ButtonFilled from "../../components/ButtonFilled";
import {post} from "../../api/request";
import {configureTransport} from "../../api/transport";
import Loader from "../../components/Loader";
import {useAlert} from "../../components/AlertNotification";

const Login = () => {

    const alertU = useAlert();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const submitTimeoutRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [isViewPassword, setIsViewPassword] = useState(false);
    const [remember, setRemember] = useState(false);
    const [errors, setErrors] = useState({
        login: '',
        password: ''
    });

    const validation = () => {
        let valid = true;
        const trimmedLogin = login.trim();
        const trimmedPassword = password.trim();
        
        if (!trimmedLogin) {
            setErrors((prev) => ({
                ...prev,
                login: 'Поле обязательно для заполнения'
            }))
            valid = false;
        }
        if (!trimmedPassword) {
            setErrors((prev) => ({
                ...prev,
                password: 'Поле обязательно для заполнения'
            }))
            valid = false;
        }
        return valid
    };

    const handleChangeLogin = (evt) => {
        setLogin(evt.target.value);
        setErrors((prev) => ({
            ...prev,
            login: ''
        }))
    };

    const handleChangePassword = (evt) => {
        setPassword(evt.target.value);
        setErrors((prev) => ({
            ...prev,
            password: ''
        }))
    };

    const submitHandler = async (e) => {
        if (e) {
            e.preventDefault();
        }
        
        if (isLoading) return;
        
        if (submitTimeoutRef.current) {
            clearTimeout(submitTimeoutRef.current);
        }
        
        submitTimeoutRef.current = setTimeout(() => {
            submit(e);
        }, 300);
    };

    const submit = async (e) => {
        if (e) {
            e.preventDefault();
        }
        
        if (isLoading) return;
        
        if (!validation()) return;
        setIsLoading(true);

        const requestData = {
            username: login.trim(),
            password: password.trim(),
            rememberMe: remember
        };

        post('login', requestData)
            .then(async (response) => {
                try {
                    const status = response?.status;
                    const tokens = response?.data?.tokens;
                    const user = response?.data?.user;
                    
                    if (response && status === 'success' && tokens && tokens.accessToken) {
                        localStorage.removeItem('access_token');
                        localStorage.removeItem('refresh_token');
                        localStorage.removeItem('user');
                        localStorage.removeItem('token_received');
                        localStorage.removeItem('expires_in');
                        
                        localStorage.setItem('rememberMe', remember.toString());
                        
                        dispatch(setTokens({
                            accessToken: tokens.accessToken,
                        }));
                        
                        configureTransport(tokens.accessToken);
                        
                        dispatch(setUser(user));
                        navigate('/app/main');
                    } else {
                        alertU({
                            status: 'error',
                            title: 'Ошибка авторизации',
                            message: response?.message || response?.data?.message || 'Неверный формат ответа от сервера'
                        });
                    }
                } catch (error) {
                    alertU({
                        status: 'error',
                        title: 'Ошибка авторизации',
                        message: error?.message || 'Ошибка при обработке ответа от сервера'
                    });
                }
            })
            .catch((e) => {
                if (e?.response?.data?.status === 'error') {
                    if (e?.response?.data?.message === 'Password or username are wrong') {
                        alertU({
                            status: 'error',
                            title: 'Авторизация',
                            message: 'Неверный логин или пароль'
                        });
                    } else if (e?.response?.data?.message === 'Password length must be at least 8 characters long') {
                        alertU({
                            status: 'error',
                            title: 'Авторизация',
                            message: 'Минимальная длина пароля: 8 символов'
                        });
                    } else {
                        alertU({
                            status: 'error',
                            title: 'Ошибка',
                            message: 'Ошибка'
                        });
                    }
                } else {
                    alertU({
                        status: 'error',
                        title: 'Ошибка',
                        message: 'Ошибка'
                    });
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };


    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && !isLoading) {
            submitHandler(e);
        }
    };

    return (

        <div className="login-page">
            <div className="login-form__wrapper">
                <div className="login__right" onKeyPress={handleKeyPress}>
                    <div className="sign-in__wrap-input">
                        <Input
                            value={login}
                            onChange={handleChangeLogin}
                            leftIcon="profile"
                            placeholder="Логин"
                            error={errors.login}/>
                    </div>
                    <div className="sign-in__wrap-input">
                        <Input
                            value={password}
                            onChange={handleChangePassword}
                            leftIcon="lock"
                            rightIcon={isViewPassword ? "eye" : "eye-lock"}
                            onClickRight={() => setIsViewPassword(prev => !prev)}
                            type={isViewPassword ? "text" : "password"}
                            placeholder="Пароль"
                            error={errors.password}/>
                    </div>
                    <div className="sign-in__wrap-checkbox">
                        <CheckBox
                            text="Запомнить"
                            value={remember}
                            onChange={setRemember}/>
                    </div>
                    <div className="sign-in__wrap-btn">
                        <ButtonFilled
                            text="Войти"
                            onClick={submitHandler}/>
                    </div>
                    <div className="sign-in__wrap-recovery">
                        <Link text="Забыли пароль?" to="/auth/password-recovery" translate="no"/>
                    </div>

                </div>

                <div className="login__left">
                    <img src="/img/login-img.png" alt="img"/>
                </div>
            </div>

            {isLoading && (
                <Loader/>
            )}
        </div>

    );
};

export default Login;
